<template>
  <div class="wrapper" :class="{wrapper_absolute: absolute}">
    <div
      class="loader"
      :class="typeClass"
      :style="{width: size, height: size, 'border-width': border}"
    ></div>
  </div>
</template>

<script>
export default {
  props: {
    size: {
      default: '70px',
    },
    border: {
      default: '6px',
    },
    absolute: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'primary',
      validator(value) {
        return ['primary', 'negative'].includes(value);
      },
    },
  },
  computed: {
    typeClass() {
      if (this.type === 'negative') {
        return 'loader_negative';
      }

      return undefined;
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;

  &_absolute {
    width: auto;
    position: absolute;
    display: flex;
    align-items: center;
    background-color: var(--bg);
    left: 1px;
    right: 1px;
    top: 1px;
    bottom: 1px;
  }
}

.loader {
  border-radius: 50%;
  margin: 0 auto;
  position: relative;
  border: 6px solid $loader-secondary;
  border-left: 6px solid $primary;
  transform: translateZ(0);
  animation: load 1.1s infinite linear;

  &_negative {
    border-color: var(--bg-danger-faded);
    border-left-color: var(--bg-danger);
  }
}

@keyframes load {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
